import React from "react";
import "./css/Journey.css";
import launch from "./img/launch.png";

const journey = [
  {
    id: "1",
    mainText: "Our Vision",
    mainDes:
      "To help you to become a true professional to tackle the hinderance at early stage",
  },
  {
    id: "2",
    mainText: "Our Mission",
    mainDes:
      "To nourish young brains to purse their passion and career in tech-industry",
  },
  {
    id: "3",
    mainText: "Our Work",
    mainDes:
      "Provide platform to achieve your dream and and make fortune right from college days",
  },
];

function Journey() {
  return (
    <div className="journey">
      <div className="journey-container">
        <p>Launch Your Career With Us</p>
      </div>
      <div className="launch">
        <img src={launch} alt="launch" />
      </div>
      <div className="journey-expects">
        {journey.map((data) => (
          <>
            <div id={data.id} className="journey-expects-container">
              <p className="main">{data.mainText}</p>
              <p>{data.mainDes}</p>
            </div>
          </>
        ))}
      </div>
    </div>
  );
}

export default Journey;
